import React, {useState} from "react";
import {Button, Form} from "react-bootstrap";
import {CustomModal} from "../components/CustomModel/CustomModal";
import FeatherIcon from "feather-icons-react";
import {Link, useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import MiniLoader from "../components/MiniLoader";
import axios from "axios";
import GoogleAuth from "../components/GoogleAuth";
import FacebookAuth from "../components/FacebookAuth";
import i18n from "i18next";

const Login = () => {
    const { t } = useTranslation();
    document.title=t("Sign Up")
    // let { loginUser } = useContext(AuthContext)

    const [loader, setLoader] = useState(false)
    const [emailError, setEmailError] = useState()
    const [firstNameError, setFirstNameError] = useState()
    const [lastNameError, setLastNameError] = useState()

    const [success, setSuccess] = useState(false)
    // let [role, setRole] = useState(1);

    let history = useHistory()

    const [isPolicyAccepted, setIsPolicyAccepted] = useState(false);
    const [submitAttempted, setSubmitAttempted] = useState(false);
    const [showPolicyModal, setShowPolicyModal] = useState(false);

    let newUser = async (e) => {
        e.preventDefault()
        setSubmitAttempted(true);

        if (!isPolicyAccepted) {
            toast.error(t("Please accept the Privacy Policy first"));
            return;
        }

        setLoader(true)
        setEmailError(null)
        setFirstNameError(null)
        setLastNameError(null)

        try {
            let data = {
                'email': e.target.email.value,
                'first_name': e.target.first_name.value,
                'last_name': e.target.last_name.value,
            }
            let config = {
                headers : {
                    "Accept-Language": i18n.language
                }
            }

            await axios.post( '/api/v1.0/auth/sign-up/', data, config)

            setSuccess(true)
            toast(t("Account created"), {type: "success"})
        }
        catch (error) {
            if (error.response.status === 500) {
                history.push('/500')
            }
            if('email' in error.response.data)
                setEmailError(error.response.data.email)
            if ('first_name' in error.response.data)
                setFirstNameError(error.response.data.first_name)
            if ('last_name' in error.response.data)
                setLastNameError(error.response.data.last_name)
        }
        finally {
            setTimeout(() => {setLoader(false)}, 200)
        }
    }

    return (
            <div className="auth-card">
                <center>
                    <h2>{t("Sign Up")}</h2>
                </center>
                { success ? (
                    <div className="success text-center">
                        <p>{t("Account created. Letter for log-in to the system has been sent to the mail.")}</p>
                    </div>
                ) : (
                    <>
                        <div className={`auth-checkbox-container ${!isPolicyAccepted && submitAttempted ? 'auth-checkbox-error' : ''}`}>
                            <Form.Check
                                id="privacyPolicyCheckbox"
                                type="checkbox"
                                checked={isPolicyAccepted}
                                onChange={(e) => {
                                    setIsPolicyAccepted(e.target.checked);
                                    if(e.target.checked) setSubmitAttempted(false);
                                }}
                            />
                            <div style={{position: "absolute", left: "35px", top: "0"}}>
                                <label style={{ cursor: 'pointer' }}>
                                    {t("I agree to the")} <Link to="#" onClick={(e) => { e.preventDefault(); e.stopPropagation(); setShowPolicyModal(true); }}>{t("Privacy Policy")}</Link>
                                </label>
                            </div>
                        </div>

                        <div 
                            className={`social-media ${!isPolicyAccepted ? 'auth-social-disabled' : ''}`}
                            onClickCapture={(e) => {
                                if (!isPolicyAccepted) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    toast.error(t("Please accept the Privacy Policy first"));
                                    setSubmitAttempted(true);
                                }
                            }}
                        >
                            <GoogleAuth />
                            <FacebookAuth />
                        </div>
                        
                        <div className="auth-divider">OR</div>

                        <Form onSubmit={newUser} className={loader ? "hide" : ""}>
                            <Form.Group className="mb-3">
                                <Form.Label>{t("Email address")} *</Form.Label>
                                <Form.Control
                                    required
                                    type="email"
                                    placeholder={t("Enter email")}
                                    name="email"
                                />
                                {emailError && (
                                    <Form.Text className="text-danger mt-1">
                                        <FeatherIcon icon="alert-circle" size="14" /> {t(emailError)}
                                    </Form.Text>
                                )}
                            </Form.Group>
                            
                            <div className="d-flex" style={{ gap: '15px' }}>
                                <Form.Group className="mb-3 flex-fill">
                                    <Form.Label>{t("First name")}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder={t("Enter first name")}
                                        name="first_name"
                                    />
                                    {firstNameError && (
                                        <Form.Text className="text-danger mt-1">
                                            <FeatherIcon icon="alert-circle" size="14" /> {t(firstNameError)}
                                        </Form.Text>
                                    )}
                                </Form.Group>

                                <Form.Group className="mb-4 flex-fill">
                                    <Form.Label>{t("Last name")}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder={t("Enter last name")}
                                        name="last_name"
                                    />
                                    {lastNameError && (
                                        <Form.Text className="text-danger mt-1">
                                            <FeatherIcon icon="alert-circle" size="14" /> {t(lastNameError)}
                                        </Form.Text>
                                    )}
                                </Form.Group>
                            </div>

                            <Button 
                                variant="green" 
                                type="submit" 
                                className="w-100 py-2"
                                onClick={() => setSubmitAttempted(true)}
                            >
                                {t("Sign Up")}
                            </Button>
                        </Form>

                        <div className="auth-footer mt-4">
                            <span style={{ color: '#6b7280', marginRight: '5px' }}>{t("Already have an account?")}</span>
                            <Link to="/login">{t("Sign in instead")}</Link>
                        </div>
                    </>
                )}
                { loader && (
                    <div className="center-block">
                        <center>
                            <MiniLoader />
                        </center>
                    </div>
                )}
                <CustomModal isOpen={showPolicyModal} onClose={() => setShowPolicyModal(false)} maxWidth="800px">
                    <form className="modal-form">
                        <h2>
                            <FeatherIcon icon="file-text" /> {t("Privacy Policy Title")}
                        </h2>
                        <p><i>{t("General provisions")}</i></p>
                        <p>{t("General provisions text")}</p>

                        <p><i>{t("Data collection title")}</i></p>
                        <p>{t("Data collection text")}</p>

                        <p><i>{t("Data protection title")}</i></p>
                        <p>{t("Data protection text")}</p>

                        <p><i>{t("Third-party transfer title")}</i></p>
                        <p>{t("Third-party transfer text")}</p>

                        <p><i>{t("User rights title")}</i></p>
                        <p>{t("User rights text")}</p>

                        <p><i>{t("Policy changes title")}</i></p>
                        <p>{t("Policy changes text")}</p>

                        <p className="mini">
                            {t("Last updated")}: {new Date().toLocaleDateString()}
                        </p>
                    </form>
                </CustomModal>
            </div>
    )
}


export default Login